import "./preferences.css";
import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setPreference, togglePreference } from "./preferencesActions";
import { AppSettings } from "./parts/AppSettings";
import { ResearchInterests } from "./parts/ResearchInterests";
import { DOMICILE } from "../../redux/slices/api/initialisePreferences";
import { isInternalUser } from "../../lib/entitlements";
import { isIntranetPath } from "../../lib/routing";
import useIsMobile from "../../lib/hooks/useIsMobile";

export function Preferences() {
  const isMobile = useIsMobile();
  const domicile = useSelector((state) => state.preferences[DOMICILE])[0];
  const dispatch = useDispatch();

  return (
    <section className={"bg-dark text-light"}>
      <article className="user-profile py-4 px-2 mb-0 h-100 maxw-600 rounded-0">
        <Tabs defaultActiveKey="researchInterests">
          <Tab eventKey="researchInterests" title="Research Interests" className="pt-3">
            <ResearchInterests handleClick={(tag, preference) => handlePreferenceClick(tag, preference, dispatch)} />
          </Tab>

          <Tab eventKey="appSettings" title="App Settings" className="pt-3">
            <AppSettings handleClick={(tag, preference) => handlePreferenceClick(tag, preference, dispatch)} />
          </Tab>
        </Tabs>
      </article>
    </section>
  );
}

const handlePreferenceClick = (tag, preference, dispatch) => {
  if (preference.noMultiSelect) {
    dispatch(setPreference({ key: preference.id, value: tag }));
  } else {
    dispatch(togglePreference({ key: preference.id, value: tag, preference }));
  }
};
